import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { AppState } from 'store/types/Store';

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
